export const SET = 'creditdecision//SET'

export function setCreditDecision(data) {
  return {
    type: SET,
    payload: data,
  }
}

export function getCreditDecision(store) {
  return store.creditDecision.data
}

const initialState = {
  data: { data: {} },
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        data: action.payload,
      }

    default:
      return state
  }
}
